

const DoctorAppointmentViewFilters = {
  default: [
      {
    label: "Status",
    key: "status",
    options: ["Completed", "Today", "Cancelled", "Upcoming"],
  },

  
      {
  label: "Gender",
  key: "gender",
  options: [
    "Male",
    "Female",
  ]
},

  ],
  additional: [
  {
      label: "Date",
      key: "appointmentDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default DoctorAppointmentViewFilters;